export default {
  executives: [
    {
      name: 'Tim Chen',
      title: 'Chief Executive Officer',
      description:
        "Meet Tim. Tim is our founder and CEO — a job that's kept him pretty busy over the past nine years. After college he worked on Wall Street and quickly realized there isn't much transparency when it comes to personal finance. So, in 2009, he and co-founder Jake Gibson started NerdWallet. When he's not helping to bring clarity to people's financial decisions, you can find him reading, playing his guitar or enjoying the Bay Area's spectacular geography and climate. Tim has a bachelor's degree in economics from Stanford University.",
      image: 'tim_chen_desktop.jpg',
      imageMobile: 'tim_chen_mobile.jpg',
      imageRollover: 'tim_chen_rollover.png',
      imageAlt: 'Tim Chen',
    },
    {
      name: 'Lauren St. Clair',
      title: 'Chief Financial Officer',
      description:
        "Meet Lauren. Lauren leads NerdWallet's financial operations with a focus on expanding domestic and international growth. She has more than 18 years of experience working in finance for both startups and multinational corporations, including CFO of North America at eBay and CFO at StubHub International in Spain. Lauren has a BS degree from Stanford University and an MBA from Duke University.",
      image: 'lauren_stclair_desktop.jpg',
      imageMobile: 'lauren_stclair_mobile.jpg',
      imageRollover: 'lauren_stclair_desktop.jpg',
      imageAlt: 'Lauren St. Clair',
    },
    {
      name: 'Kelly Gillease',
      title: 'Chief Marketing Officer',
      description:
        "Meet Kelly. Kelly is passionate about Marketing products that can have a truly positive impact and enrich people's lives. She's spent nearly 20 years in Marketing at startups in travel, edTech and search. Kelly's participated in three strategic startup acquisitions as a part of Marketing leadership at Hotwire, Viator and StudyBlue. Outside of NerdWallet Kelly's competed in the American Crossword Puzzle tournament, practices yoga and enjoys time with her son. Kelly is a graduate of UC Berkeley with dual BA degrees in Economics and English.",
      image: 'kelly_gillease_desktop.jpg',
      imageMobile: 'kelly_gillease_mobile.jpg',
      imageRollover: 'kelly_gillease_rollover.png',
      imageAlt: 'Kelly Gillease',
    },
    {
      name: 'Robert Lattuga',
      title: 'General Counsel and VP, People Operations',
      description:
        "Meet Robert. Robert makes sure NerdWallet is always in compliance and running by the book. He's led teams and solved tough legal issues for LeapFrog Enterprises and Venture Law Group. But he's not just a legal Nerd — he also has a physics degree! On the weekends, you can find him out with his wife and three dogs, building away in his woodshop or catching up on the latest episode of \"This American Life.\" Robert has a J.D. from the University of California, Berkeley School of Law, a master's degree in physics from Harvard and a bachelor's degree in physics from the University of California.",
      image: 'robert_lattuga_desktop.jpg',
      imageMobile: 'robert_lattuga_mobile.jpg',
      imageRollover: 'robert_lattuga_rollover.png',
      imageAlt: 'Robert Lattuga',
    },
    {
      name: 'Tracy Mahnken',
      title: 'VP, Product',
      description:
        'Meet Tracy. Tracy leads a diverse team of product managers and business development pros who are busy growing our emerging businesses. She has over 20 years of product management, marketing, research and sales operations experience in the real estate and CPG industries. Outside of work, for Tracy, usually means being outside with her three teenage Boy Scouts. Her ideal Saturday night includes board games with friends — glass of wine in hand! Tracy has a BA in Economics from the University of Washington.',
      image: 'tracy_mahnken_desktop.jpg',
      imageMobile: 'tracy_mahnken_mobile.jpg',
      imageRollover: 'tracy_mahnken_rollover.png',
      imageAlt: 'Tracy Mahnken',
    },
    {
      name: 'David Zabowski',
      title: 'VP, Engineering',
      description:
        "Meet David. David loves building software that makes people's lives better. Throughout his 20-year career, David has built and scaled consumer experiences at companies ranging from tiny startups to heavy hitters like Intuit and Yahoo. When David isn't working hard to ensure NerdWallet has the best engineering talent and tech, you can find him cycling, working on his house or hanging with his wife. David has a bachelor's degree in applied mathematics/computer science from Carnegie Mellon University.",
      image: 'david_zabowski_desktop.jpg',
      imageMobile: 'david_zabowski_mobile.jpg',
      imageRollover: 'david_zabowski_rollover.png',
      imageAlt: 'David Zabowski',
    },
    {
      name: 'Cameron Carr',
      title: 'VP, Data',
      description:
        "Meet Cameron. Cameron loves finding insight in massive data sets and building analytic tools and teams that shape better customer experiences. Over the past 18 years, Cameron has led data science and analytics organizations for some of the top tech companies, including Netflix, PlayStation and Facebook. When not at work, you can find Cameron cooking, building guitars, enjoying California's outdoors, or simply hanging out with his cats. Cameron has a BSc in BioPsychology from The College of William & Mary, and an MBA from Georgetown McDonough School of Business.",
      image: 'cameron_carr_desktop.jpg',
      imageMobile: 'cameron_carr_mobile.jpg',
      imageRollover: 'cameron_carr_rollover.png',
      imageAlt: 'Cameron Carr',
    },
    {
      name: 'Kevin Yuann',
      title: 'VP, Business',
      description:
        "Meet Kevin. Kevin not only grows the largest revenue-generating businesses at NerdWallet, he's also been an essential example of how to scale a team successfully. Before joining NerdWallet, Kevin led a team at Visa, where he focused on strategy and operations. When Kevin isn't going big, he's going home to chase his kids, read the encyclopedia (well, the electronic version) and rock out to the Beastie Boys. Kevin has an MBA from UCLA Anderson School of Management and a bachelor's degree in economics from Brown University.",
      image: 'kevin_yuann_desktop.jpg',
      imageMobile: 'kevin_yuann_mobile.jpg',
      imageRollover: 'kevin_yuann_rollover.png',
      imageAlt: 'Kevin Yuann',
    },
    {
      name: 'Maggie Leung',
      title: 'VP, Content',
      description:
        "Meet Maggie. She uses her journalism skills to help people understand the world. At NerdWallet, she's built a team of more than 80 writers and editors who help inform consumers about all things personal finance. She's a seasoned journalist who spent about 20 years at news outlets including CNN, The Wall Street Journal and The Washington Post. When she's not helping people live richer lives, she's searching for adventure. You can find her road-tripping or escaping into a book. Maggie has a bachelor's degree in journalism from San Francisco State University.",
      image: 'maggie_leung_desktop.jpg',
      imageMobile: 'maggie_leung_mobile.jpg',
      imageRollover: 'maggie_leung_rollover.png',
      imageAlt: 'Maggie Leung',
    },
    {
      name: 'Jeff Mahacek',
      title: 'VP, Design',
      description:
        "Meet Jeff. Jeff loves making people's lives better through research and design. Over his 20-year career in user experience, Jeff has created solutions for the employees of Petco, the users of Intel's PC and tablet platforms, and millions of Americans looking to improve their financial lives with Experian. Headphones in tow, Jeff is often found rocking out to Lizzo or an original Sondheim cast album, or paying way too much attention to his puppy, CJ. He has a bachelor's degree in theater from Bradley University, which he credits for giving him the ability to pretend like he can do anything.",
      image: 'jeff_mahacek_desktop.jpg',
      imageMobile: 'jeff_mahacek_mobile.jpg',
      imageRollover: 'jeff_mahacek_rollover.png',
      imageAlt: 'Jeffrey Mahacek',
    },
    {
      name: 'Lynee Luque',
      title: 'VP, People',
      description:
        'Meet Lynee. Lynee helps companies thrive by building culture and fostering scale-proof growth. At NerdWallet, she leads the HR, Workplace and Talent teams. Over a nearly 20-year long career, she’s shaped global organizations including Twitter, Mozilla, Intel, Envoy and more; and currently she sits on the board for Management Leadership Tomorrow. When she’s not nerding out, she can be found visiting boutique, family-owned wineries and vineyards in Northern California or spending time in her favorite city in the world, New York. Lynee has an MBA from University of Michigan, and a BS in Finance and Accounting from UC Berkeley.',
      image: 'lynee_luque_desktop.jpg',
      imageMobile: 'lynee_luque_mobile.jpg',
      imageRollover: 'lynee_luque_rollover.jpg',
      imageAlt: 'Lynee Luque',
    },
  ],
};
